

































































































































































































































































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import MailboxVerificationGmailConfirmationLinkFinder from './mailbox-verification-gmail-confirmation-link-finder.vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'MailboxVerificationInstructionsGoogleBusiness',
  components: {
    MailboxVerificationGmailConfirmationLinkFinder,
  },
  props: {
    incomingEmailAddress: {
      type: String,
      required: true,
    },
    forwardingFromAddress: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ColorAssistant,
      curStep: 1,
      emailCopied: false,
      normalAutoForwarding: true,
    }
  },
  computed: {
    stepPercentage(): Number {
      return Math.round(((this.curStep - 1) / (this.stepCount - 1)) * 100)
    },
    isConfirmationEmailStep(): boolean {
      return this.curStep === 4
    },
    currentRef(): any {
      return this.normalAutoForwarding
        ? this.$refs.googleNormCarousel
        : this.$refs.googleRoutingCarousel
    },
    stepCount(): number {
      return this.normalAutoForwarding ? 6 : 7
    },
  },
  methods: {
    updateStep(curItem: any) {
      this.curStep = curItem + 1
      // Reset copied email...
      this.emailCopied = false
    },
    goToNextItem() {
      // @ts-ignore
      this.currentRef.setActiveItem(this.curStep)
    },
    goToPrevItem() {
      // @ts-ignore
      this.currentRef.setActiveItem(this.curStep - 2)
    },
    goToFirstItem() {
      // @ts-ignore
      this.currentRef.setActiveItem(0)
    },
  },
})
